"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * NotFoundPage
 *
 * This is the page we show when the user visits a url that doesn't have a route
 *
 */
var material_1 = require("@mui/material");
var BlendButton_1 = __importDefault(require("atomicComponents/molecules/Buttons/BlendButton"));
var BackgroundText_1 = __importDefault(require("./styles/BackgroundText"));
var ImagePlaceholder_1 = __importDefault(require("./styles/ImagePlaceholder"));
var NotFoundHeader_1 = __importDefault(require("./styles/NotFoundHeader"));
var NotFound = function () { return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ maxWidth: 1200, display: "flex", alignItems: "center", width: "100%", height: "100%", margin: "0 auto", justifyContent: { xs: 'center', md: 'space-between' }, flexDirection: { xs: 'column', md: 'row' } }, { children: [(0, jsx_runtime_1.jsx)(BackgroundText_1.default, { children: "404" }), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ mt: 3, display: "flex", flexDirection: "column", alignItems: { xs: 'center', md: 'flex-start' } }, { children: [(0, jsx_runtime_1.jsx)(NotFoundHeader_1.default, { children: "Oops! This page does not exist on our site!" }), (0, jsx_runtime_1.jsx)(BlendButton_1.default, __assign({ url: "/", color: "secondary" }, { children: "Go back to Home" }))] })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ maxWidth: 500, width: "100%" }, { children: (0, jsx_runtime_1.jsx)(ImagePlaceholder_1.default, { src: "/404.png", alt: "404 illustrated by Storyset" }) }))] }))); };
exports.default = NotFound;
